import { ButtonSecondary } from "components/Clickable/Buttons";
import {
    AddToFavoritesPDPContent,
    AddToFavoritesRulesetContent,
} from "components/VisualConfigurator/AddToFavoritesContent";
import { DialogTrigger, Pressable } from "react-aria-components";

import HeartIcon from "../../public/svg/heart.svg";
import { Modal } from "../Modal";

import styles from "./add-to-favorites-button.module.scss";

export const AddToFavoritesButton = ({
    className,
    isRuleset,
}: {
    className?: string;
    isRuleset?: boolean;
}) => {
    const classes = className ? `${className}` : styles.button;

    return (
        <DialogTrigger>
            <Pressable>
                <ButtonSecondary className={classes} type="button">
                    Add to Favorites
                    <HeartIcon />
                </ButtonSecondary>
            </Pressable>
            <Modal>
                {isRuleset ? (
                    <AddToFavoritesRulesetContent intent="Add" />
                ) : (
                    <AddToFavoritesPDPContent intent="Add" />
                )}
            </Modal>
        </DialogTrigger>
    );
};
